export class ContractPartnerOspAssignment {
  recordId?: number;
  relatedContractPartner?: number;
  contractPartnerName?: string;
 
  constructor(data: any) {
    this.recordId = data[3]?.value;
    this.relatedContractPartner = data[8]?.value;
    this.contractPartnerName = data[9]?.value;
  }
}
